import { Component, OnInit, Input, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { AbstractComponent } from '../util/abstract.component';
import { SessaoService } from '../services/sessao.service';
import { Endereco } from '../modelo/endereco';
import { RestClientService } from '../services/restclient.service';
import { MensagemService } from '../services/mensagem.service';
import { EnderecoService } from '../services/endereco.service';
import { Contrato } from '../modelo/contrato';
import { BraAlertComponent } from '../componentes/bra-alert/bra-alert.component';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Config } from '../services/config';


declare var $: any;

@Component({
  selector: 'app-endereco-modal-confirmar',
  templateUrl: './endereco-modal-confirmar.component.html',
  styleUrls: ['./endereco.component.css'],
  providers: [EnderecoService, MensagemService, RestClientService]
})
export class EnderecoModalConfirmarComponent extends AbstractComponent implements OnInit {
  
  contrato: Contrato;
  enderecoAtual: Endereco;
  enderecoNovo: Endereco;
  veioSegundaViaCarne: string = 'N';


  constructor(
    private enderecoService: EnderecoService,
    private mensagemService: MensagemService,
    private router: Router,
    private sessaoService: SessaoService,
    private spinnerService: Ng4LoadingSpinnerService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<EnderecoModalConfirmarComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    super(sessaoService);
  }

  /**
   * Método chamado na inicialização
   */
  ngOnInit() {
    setTimeout(function () {
      $('.cdk-global-overlay-wrapper').css({ 'align-items': "flex-end" });
    }, 0);
    this.enderecoAtual = this.data.enderecoAtual;
    this.enderecoNovo = this.data.enderecoNovo;
    this.contrato = this.data.contrato;
    this.veioSegundaViaCarne = sessionStorage.getItem('veioSegundaViaCarne');
  }

  /**
   * Efetua a efetivação da alteração do endereço
   */
  confirmar() {
    this.fechar();
    this.enderecoService.efetivarEndereco(
      this.contrato.nuContrato,
      this.enderecoNovo.dsEndereco,
      this.enderecoNovo.nuEndereco,
      this.enderecoNovo.dsComplemento,
      this.enderecoNovo.dsBairro,
      this.enderecoNovo.dsCidade,
      this.enderecoNovo.cdUf,
      this.enderecoNovo.cdCep
    ).subscribe(
      (result: Endereco) => {
        if (result.cdMsgemRetorno == "0") {
          if(this.veioSegundaViaCarne == "S"){
            this.router.navigate(['/BF-Portal/segundaviacarneEndereco']);
          }
          else {
            if(result.lstMensagem.length > 0){
              var resultado = result.lstMensagem[0];
              sessionStorage.setItem('endereco', JSON.stringify(resultado.dsMensagem));
            }
            this.router.navigate(['/BF-Portal/enderecoConclusao']);
          }
          this.fechar();
        }
        else {
          this.dialog.open(BraAlertComponent, {
            width: Config.POPUP_50VW,
            data: {
              mensagem: result.dsMsgemRetorno
            }
          });
        }
      },
      (error: Response) => {
        this.fechar();
        this.mensagemService.servicoIndisponivel(this.getMensagem("ERRO_CHAMADA_SERVICO"));
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

  /**
   * Fecha a modal
   */
  fechar() {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/bf-endereco-cli/endereco-modal-confirmar.component.ts